import React, { lazy, Suspense } from 'react';
var SmartDocumentWriter = lazy(function () {
  return import('./SmartDocumentWriter');
});

var renderLoader = function renderLoader() {
  return React.createElement("p", null, "Loading");
};

var DocumentWriterLazy = React.forwardRef(function (props, ref) {
  return React.createElement(Suspense, {
    fallback: renderLoader()
  }, React.createElement(SmartDocumentWriter, Object.assign({}, props, {
    ref: ref
  })));
});
export default DocumentWriterLazy;